<div class="thumbnail-enlarge-dialog-container">
  <img [class.loading]="!loaded" [src]="source" #canvas (load)="loaded = true" />
  @if (!loaded) {
    <div class="loading-container">
      <mat-spinner diameter="32" strokeWidth="4" mode="indeterminate" />
    </div>
  }
</div>
